import { GUARANTEE_FRONT_LIB_CONFIG as DEFAULT_CONFIG, GuaranteeFrontLibConfig } from 'guarantee-front-lib'
import { AppRoutes } from '../../shared/constants/enums'

export const GUARANTEE_FRONT_LIB_CONFIG: GuaranteeFrontLibConfig = {
    ...DEFAULT_CONFIG,
    errorDateFromTo: {
        translatePath: 'validationMessages'
    },
    previousValueTooltip: {
        ...DEFAULT_CONFIG.previousValueTooltip,
        iconUrl: './assets/icons/Change.svg'
    },
    guaranteePreviousValueTooltip: {
        ...DEFAULT_CONFIG.guaranteePreviousValueTooltip,
        iconUrl: './assets/icons/Box.svg'
    },
    navigation: {
        ...DEFAULT_CONFIG.navigation,
        tabNavigationRegexes: [
            {
                navigationGroupId: 1,
                navigationLevel: 1,
                regex: new RegExp(`^/${AppRoutes.GUARANTEE_ORDERS}/(\\d+)/[\\w-]+$`),
                regexGroupIndexesWithIds: [1]
            }
        ],
        ignoredUrlRegexes: [
            new RegExp(`^.*/edit(/.*)?$`),
            new RegExp(`^.*/new(/.*)?$`),
            new RegExp(`^/${AppRoutes.GUARANTEE_ORDERS}/new-annex(/.*)?$`)
        ]
    }
}
